export class ObjectUtils {
    constructor() {}

    /**
     * Performs a deep merge of objects and returns new object. Does not modify
     * objects (immutable) and merges arrays via concatenation.
     * See https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
     *
     * @param {...object} objects - Objects to merge
     * @returns {object} New object with merged key/values
     */
    static mergeDeep(...objects: any[]) {
        const isObject = (obj: any) => obj && typeof obj === "object";

        return objects.reduce((prev, obj) => {
            Object.keys(obj).forEach((key) => {
                const pVal = prev[key];
                const oVal = obj[key];

                if (Array.isArray(pVal) && Array.isArray(oVal)) {
                    // unique value arrays
                    // prev[key] = [...pVal, ...oVal].filter((element, index, array) => array.indexOf(element) === index);
                    // prev[key] = pVal.concat(...oVal); // non unique arrays
                    // Ausnahme für layerTemplates TODO: bessere Lösung finden
                    if (key === "layerTemplates"){
                        prev[key] = pVal.concat(...oVal); // non unique arrays
                    }
                    else {
                        prev[key] = oVal; // don't merge arrays
                    }
                }
                else if (isObject(pVal) && isObject(oVal)) {
                    prev[key] = ObjectUtils.mergeDeep(pVal, oVal);
                }
                else {
                    prev[key] = oVal;
                }
            });

            return prev;
        }, {});
    }

}

